import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Button } from "@shared/ui/button";
import { Textarea } from "@shared/ui/textarea";

interface PriorityNotesSectionProps {
  priority: string;
  onPriorityChange: (priority: string) => void;
  notes: string;
  onNotesChange: (notes: string) => void;
}

const priorityOptions = [
  {
    value: "critical",
    label: "Critical",
    color: "bg-red-500 hover:bg-red-600 text-white",
  },
  {
    value: "high",
    label: "High",
    color: "bg-orange-500 hover:bg-orange-600 text-white",
  },
  {
    value: "medium",
    label: "Medium",
    color: "bg-blue-500 hover:bg-blue-600 text-white",
  },
  {
    value: "low",
    label: "Low",
    color: "bg-green-500 hover:bg-green-600 text-white",
  },
];

export const PriorityNotesSection: React.FC<PriorityNotesSectionProps> = ({
  priority,
  onPriorityChange,
  notes,
  onNotesChange,
}) => {
  return (
    <Card className="bg-white border border-gray-200 rounded-lg shadow-sm">
      <CardHeader>
        <CardTitle className="text-lg font-semibold text-gray-900">
          Priority & Notes
        </CardTitle>
      </CardHeader>

      <CardContent className="space-y-6">
        {/* Priority Level */}
        <div>
          <label className="block text-sm font-medium text-gray-900 mb-3">
            Priority Level
          </label>
          <div className="flex gap-3">
            {priorityOptions.map((option) => (
              <Button
                key={option.value}
                onClick={() => onPriorityChange(option.value)}
                variant={priority === option.value ? "default" : "outline"}
                className={`transition-colors ${
                  priority === option.value
                    ? option.color
                    : "border-gray-300 text-gray-700 hover:bg-gray-50 bg-white"
                }`}
              >
                {option.label}
              </Button>
            ))}
          </div>
        </div>

        {/* Notes */}
        <div>
          <label className="block text-sm font-medium text-gray-900 mb-2">
            Notes
          </label>
          <Textarea
            placeholder="Add any additional notes or instructions for this service order..."
            value={notes}
            onChange={(e) => onNotesChange(e.target.value)}
            rows={4}
            className="resize-none border-gray-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
          />
        </div>
      </CardContent>
    </Card>
  );
};
